import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';
import { getQuery } from '@/helpers/utils';

export const loanService = {
  loanList: params => axios.get(Pathes.Loans.list + getQuery(params)),
  loanByFundraisingId: id => axios.get(Pathes.Loans.loansByFundraisingID(id)),
  brandsByFundraisingId: id =>
    axios.get(Pathes.Loans.brandsByFundraisingID(id)),
  loanEarningsByFundraisingId: (id, groupId) =>
    axios.get(Pathes.Loans.loanEarningsByFundraisingID(id, groupId)),
  repaymentScheduleByFundraisingId: (id, params) =>
    axios.get(
      Pathes.Loans.repaymentScheduleByFundraisingID(id) + getQuery(params),
    ),
  recoveryFundsByFundraisingId: id =>
    axios.get(Pathes.Loans.fundsInRecoveryByFundraisingID(id)),
  paymentHistoryByFundraisingId: (id, params) =>
    axios.get(
      Pathes.Loans.paymentHistoryByFundraisingID(id) + getQuery(params),
    ),
  financeAgreementsByFundraisingId: (id, params) =>
    axios.get(Pathes.Loans.agreementsByFundraisingID(id) + getQuery(params)),
  loanSecurityByFundraisingId: (id, params) =>
    axios.get(Pathes.Loans.loanSecurityByFundraisingId(id) + getQuery(params)),
  repaymentSchedule: params =>
    axios.get(Pathes.Loans.repaymentSchedule + getQuery(params)),
};
